import { resourceLabel } from '@/lib/resourceLabels'

/**
 * A grant's scope chips: one `<resource>:<level>` scope said in words, so nobody has to decode a scope string.
 * Shared by the People screen (#618), which shows an owner what everybody holds, and the account screen (#630),
 * which shows a person what they themselves hold — one vocabulary, learned once.
 */
export type ScopeChip = { key: string; label: string }

function titleCase(value: string): string {
    return value.charAt(0).toUpperCase() + value.slice(1)
}

/** `tasks:write` reads as `Tasks · Write`. A scope that is not `<resource>:<level>` is still never shown raw. */
export function scopeLabel(scope: string): string {
    const [resource = '', level = ''] = scope.split(':')
    const label = resourceLabel(resource)
    return level ? `${label} · ${titleCase(level)}` : label
}

/** One chip per scope, in the order the grant lists them. Nothing enumerated is no chips at all. */
export function scopeChips(scopes: string[] | null | undefined): ScopeChip[] {
    return (scopes ?? []).map(scope => ({ key: scope, label: scopeLabel(scope) }))
}
